import React from 'react'
import * as Sentry from '@sentry/browser'
import { connect } from 'react-redux'
import { RootState } from './store/dailyReport/types'
import { Retry } from './components/retry/Retry'
import { Toast } from './components/antd/Antd'
interface MyProps {
  children: React.ReactNode,
  status: boolean
}
interface Mystate {
  hasError: boolean
}
class Boundary extends React.Component<MyProps, Mystate> {
  constructor(props: MyProps) {
    super(props)
    this.state = {
      hasError: false,
    }
  }

  static getDerivedStateFromError() {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: true }
  }

  componentDidCatch(error: Error | null, errorInfo: any) {
    // 你同样可以将错误日志上报给服务器
    Sentry.withScope((scope) => {
      scope.setExtra('errorInfo', errorInfo)
      Sentry.captureException(error)
    })
  }

  render() {
    if (this.state.hasError || !this.props.status) {
      Toast.info('出错了~~', 1)
      return <Retry />
    }

    return this.props.children
  }
}
const mapStateToProps = (state: RootState) => {

  const { status } = state.dailyReport
  return {
    status
  }
}
export const ErrorBoundary = connect(mapStateToProps)(Boundary) 